import PropTypes from "prop-types";
import React from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import CloseIcon from "./CloseButton";

const PopupLight = ({ isActive, hidePopup, element }) => {
  return (
    <Modal
      isOpen={isActive}
      onRequestClose={hidePopup}
      className="popup-light"
      closeTimeoutMS={0}
    >
      <div className="content-container">
        <div className="hide-icon">
          <Link to="#" onClick={hidePopup}>
            <CloseIcon
              style={{
                fill: "red",
              }}
            />
          </Link>
        </div>
        <div>{element}</div>
      </div>
    </Modal>
  );
};

PopupLight.propTypes = {
  intl: PropTypes.object,
  isActive: PropTypes.bool,
  hidePopup: PropTypes.func,
  element: PropTypes.element,
  callback: PropTypes.func,
  logout: PropTypes.func,
  showClose: PropTypes.bool,
};

export default PopupLight;



// WEBPACK FOOTER //
// ./components/common/PopupLight.jsx